import { PaletteOptions } from '@mui/material';

const COMMON_COLORS = {
  black: '#000000',
  white: '#ffffff',
  // custom
  primary: '#CCC292',
  secondary1: '#807CCC',
  secondary2: '#CC8B87',
  secondary3: '#A5CCB5',
  dark1: '#16191E',
  dark2: '#27282A',
  dark3: '#2A3139',
  dark4: '#4E5C67',
  gradient: 'linear-gradient(180deg, #CDC392 0%, #938852 100%)',
};

const PRIMARY_COLOR = {
  main: COMMON_COLORS.primary,
  light: COMMON_COLORS.primary,
  dark: COMMON_COLORS.primary,
};

const TEXT_COLOR = {
  primary: COMMON_COLORS.white,
  secondary: 'rgba(255, 255, 255, 0.7)',
  disasbled: 'rgba(255, 255, 255, 0.7)',
};

const BACKGROUND_COLOR = {
  default: COMMON_COLORS.dark1,
  paper: COMMON_COLORS.white,
  box: COMMON_COLORS.dark3,
  card: COMMON_COLORS.dark3,
  body: COMMON_COLORS.dark2,
  label: '#CDC392',
  buttonGold: COMMON_COLORS.gradient,
  buttonGray: COMMON_COLORS.dark4,
};

const paletteLight: PaletteOptions = {
  common: { ...COMMON_COLORS },
  primary: { ...PRIMARY_COLOR },
  text: { ...TEXT_COLOR },
  background: { ...BACKGROUND_COLOR },
};

const paletteDark: PaletteOptions = {
  common: { ...COMMON_COLORS },
  primary: { ...PRIMARY_COLOR },
  text: { ...TEXT_COLOR },
  background: { ...BACKGROUND_COLOR },
};

export default { paletteLight, paletteDark };
